<template>
  <USelectMenu
    v-model="_value"
    :items="reservations"
    label-key="customerInfoLabel"
    by="idReservation"
    placeholder="Select an appointment"
    :filter-fields="['customerInfoLabel']"
  >
    <template #default="{ modelValue: selected }">
      <div v-if="selected" class="flex items-center">
        <p class="block opacity-90 line-clamp-1">
          {{ selected.infoLabel }}
        </p>
      </div>
    </template>

    <template #item="{ item }">
      <div v-if="item" class="flex items-center">
        <div>
          <p class="text-sm opacity-90 line-clamp-1">
            {{ item._servicesLabel }} with {{ item.employeesLabel }}
          </p>
          <p class="text-sm opacity-70 line-clamp-1">
            {{ item.dateLabel }}
          </p>
        </div>
      </div>
    </template>
  </USelectMenu>
</template>

<script setup lang="ts">
interface Props {
  modelValue?: object | null
  customer?: Record<string, any> | null
}

interface Emits {
  (e: 'update:modelValue', value: any): void
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  customer: null,
})

const emit = defineEmits<Emits>()

const { $api, $notification } = useNuxtApp()

const reservations = ref<any[]>([])

const _value = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

async function fetchReservations () {
  const idCustomer = props.customer?.idCustomer || props.customer?.id

  if (!idCustomer) {
    reservations.value = []
    return
  }

  try {
    const response = await $api.customer.reservations(String(idCustomer), {
      limit: 20,
    })

    if (response) {
      reservations.value = response.items
    }
  } catch (e: any) {
    console.log(e)
    $notification.error({ errors: e.errors })
  }
}

onMounted(() => {
  fetchReservations()
})
</script>
